<template>
  <b-modal
    id="zone-new-gate-modal"
    no-close-on-backdrop
    title="New Gate"
    no-close-on-esc
    hide-header-close
    hide-footer
    @hidden="resetForm"
  >
    <h6>Gate is set, complete the information</h6>
    <b-form-group label="Label English">
      <b-form-input v-model="gateData.label.en" />
    </b-form-group>
    <b-form-group label="Label Arabic">
      <b-form-input v-model="gateData.label.ar" />
    </b-form-group>
    <b-form-group label="Address English">
      <b-form-input v-model="gateData.formattedAddress.en" />
    </b-form-group>
    <b-form-group label="Address Arabic">
      <b-form-input v-model="gateData.formattedAddress.ar" />
    </b-form-group>

    <div
      class="d-flex"
      style="gap:10px"
    >
      <b-button
        style="flex:1"
        variant="danger"
        @click="$emit('gate-removed')"
      >
        Remove Gate
      </b-button>
      <b-button
        style="flex:1"
        variant="primary"
        :disabled="!gateData.label.en || !gateData.label.ar || !gateData.formattedAddress.en || !gateData.formattedAddress.ar"
        @click="$emit('gate-set', gateData)"
      >
        Set Gate
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BModal,
    BFormGroup,
    BFormInput,
    BButton,
  },
  setup() {
    const gateData = ref({
      label: {
        en: '',
        ar: '',
      },
      formattedAddress: {
        en: '',
        ar: '',
      },
    })

    const resetForm = () => {
      gateData.value.label.en = ''
      gateData.value.label.ar = ''
      gateData.value.formattedAddress.en = ''
      gateData.value.formattedAddress.ar = ''
    }
    return {
      resetForm,
      gateData,
    }
  },
}
</script>

<style></style>
